import { IFrameInfo } from '../main/frameInfo'

export type ParticleType = 'blood'
export interface IParticleData {
  type: ParticleType
  frameInfo: IFrameInfo
}

export const dataMap: { [key: string]: IParticleData } = {}
export const dataList: IParticleData[] = []
function create(data: IParticleData) {
  dataList.push(data)
  dataMap['' + data.type] = data
}

create({
  type: 'blood',
  frameInfo: {
    i: 1,
    y: 7,
    x: 8,
  },
})

// export function loadFrames() {
//   l.forEach(dataList, (c) => {
//     if (c.frameInfo) {
//       spriteMap.getFrame(c.frameInfo)
//       // c.frameInfo.frame = f32(c.frameInfo.i, c.frameInfo.y, c.frameInfo.x)
//     }
//   })
// }
